import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import {
    FormGroup,
    FormBuilder,
    Validators,
    FormControl
} from "@angular/forms";
import {
    AppService,
    APP_DATE_FORMATS,
    AppDateAdapter
} from "../../../../services/app.service";
import { MasterService } from "../../../../services/master.service";
import { MAT_DATE_FORMATS, DateAdapter } from "@angular/material";
import { DistributorService } from "../../../../services/distributor.service";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/map";
import { AjaxService } from "../../../../../../core/services/ajax.service";
import { Http } from "@angular/http";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: 'app-dist-delivery-detail',
    templateUrl: './dist-delivery-detail.component.html',
    styleUrls: ['./dist-delivery-detail.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: AppDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: APP_DATE_FORMATS
        }
    ]
})
export class DistDeliveryDetailComponent implements OnInit {
    @Input() parent: any;

//distributorList: any = [];

formGroup: FormGroup;
formGroupErrors: any;

distFilterCtrl: FormControl = new FormControl();
/** Subject that emits when the component has been destroyed. */
private _onDestroy = new Subject<void>();
searchFlag: boolean = true;
distributorList = [];
translations: any;
showSaveButton : Boolean = true;
constructor(
    private formBuilder: FormBuilder,
    public appService: AppService,
    private masterService: MasterService,
    private distributorService: DistributorService,
    private http: Http,
    private _ajaxService: AjaxService
) {
    this.appService.showLoading();
    this.setPageTranslations();
    this.formGroupErrors = {
        D_DistributorId: {},
        D_DeliveryWeek: {},
        D_ShipDate: {},
        D_SheepWeek: {},
        D_LicensePlate: {},
        D_T2No: {},
        D_ReceiveDate: {},
        D_ReceiveWeek: {},
        D_Remark: {},
        D_PlannedDate: {},
        D_ActualDate: {},
        D_ActualWeek: {}
    };
    this.showSaveButton = !(sessionStorage.getItem("ViewMode") == 'true');

}
scrollItem(item) {
    console.log(item);
}
changeDistributor(e) {
    this.searchFlag = false;
    this.parent.D_DistributorId = e.value;
}
ngOnInit() {
    this.loadFormGroup();
    this.filterDistributor();
    this.distFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
        this.filterDistributor();
    });

}
filterDistributor() {
    if (this.searchFlag) {
        let search = this.distFilterCtrl.value;
        this._ajaxService
            .GET("Distributor.svc/list/"
                 +(typeof this.parent.order.D_DistributorId != 'undefined' ? this.parent.order.D_DistributorId : '0')
                 +"/"+(typeof this.parent.order.C_PostalCodeId != 'undefined' ? this.parent.order.C_PostalCodeId : '0')
                 +"/" + (!search ? " " : search) + " /0")
            .subscribe(response => {
            this.distributorList = JSON.parse(response.Data);
            if (
                typeof this.parent.order.D_DistributorId == "undefined" ||
                this.parent.order.D_DistributorId <= 0
            ) {
                for (let i = 0; i < this.distributorList.length; i++) {
                    if (this.distributorList[i]["Default"]) {
                        this.parent.order.D_DistributorId = this.distributorList[i]["Id"];
                        return;
                    }
                }

                if (
                    typeof this.parent.order.D_DistributorId == "undefined" ||
                    this.parent.order.D_DistributorId <= 0
                ) {
                    this.parent.order.D_DistributorId = this.distributorList[0]["Id"];
                }

            }
            this.appService.hideLoading();
        });
    }
    this.searchFlag = true;
}
setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
}

apiFaillure(error): void {
    this.appService.showDialogue(
    this.translations.hdError,
    this.translations[error]
    );
}

loadFormGroup() {
    if (this.parent.order.Status == 152 && this.showSaveButton) {
        this.formGroup = this.formBuilder.group({
            D_DistributorId: [ {
                value: "",
                disabled: true
            }, Validators.required],
            D_DeliveryWeek: [
                {
                    value: "",
                    disabled: true
                },
                [Validators.required, Validators.min(1), Validators.max(53)]
            ],
            D_ShipDate: [ {
                value: "",
                disabled: true
            }, Validators.required],
            D_SheepWeek: [
                {
                    value: "",
                    disabled: true
                }
            ],
            D_LicensePlate: [ {
                value: "",
                disabled: true
            }, Validators.required],
            D_T2No: [ {
                value: "",
                disabled: true
            }, Validators.required],
            D_ReceiveDate: ["", Validators.required],
            D_ReceiveWeek: [
                {
                    value: "",
                    disabled: true
                }
            ],
            D_Remark: [],
            D_PlannedDate: [{
                    value: "",
                    disabled: true
                }, Validators.required],
            D_ActualDate: [{
                    value: "",
                    disabled: true
                }, Validators.required],
            D_ActualWeek: [
                {
                    value: "",
                    disabled: true
                }
            ]
        });
    } else {
        this.formGroup = this.formBuilder.group({
            D_DistributorId: [ {
                value: "",
                disabled: true
            }, Validators.required],
            D_DeliveryWeek: [
                {
                    value: "",
                    disabled: true
                },
                [Validators.required, Validators.min(1), Validators.max(53)]
            ],
            D_ShipDate: [ {
                value: "",
                disabled: true
            }],
            D_SheepWeek: [
                {
                    value: "",
                    disabled: true
                }
            ],
            D_LicensePlate: [ {
                value: "",
                disabled: true
            }],
            D_T2No: [ {
                value: "",
                disabled: true
            }],
            D_ReceiveDate: [{value: "", disabled: !this.showSaveButton }],
            D_ReceiveWeek: [
                {
                    value: "",
                    disabled: true
                }
            ],
            D_Remark: [],
            D_PlannedDate: [
                {
                    value: "",
                    disabled: true
                }
            ],
            D_ActualDate: [
                {
                    value: "",
                    disabled: true
                }
            ],
            D_ActualWeek: [
                {
                    value: "",
                    disabled: true
                }
            ]
        });
    }

    this.formGroup.valueChanges.subscribe(() => {
        this.formGroupErrors = this.appService.onFormValuesChanged(
            this.formGroup,
            this.formGroupErrors
        );
        this.appService.setFormValid(this.formGroup.invalid);
    });
}
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor-order/distributor-order-edit-form/dist-delivery-detail/dist-delivery-detail.component.ts